import tinycolor from 'tinycolor2';

const ImagesFactory = require('../images');

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'folders/' + this.id : 'folders');
  },

  parse: function (resources) {
    if (this.id && this.id.split && this.id.split('/')[1] === 'resources') {
      _.each(resources, function (resource) {
        if (resource['data']['family'] || ['data']['name'] || ['data']['default_content']) {
          resource['data']['name'] = resource['data']['name']
          || resource['data']['family'];

          resource['data']['default_content'] = resource['data']['default_content']
          || resource['data']['name']
          || resource['data']['family'];
        }
        if (resource['data']['color_code'] || ['data']['stroke_color']) {
          var b = parseInt(resource['data']['stroke_color'] / 65536);
          var g = parseInt((resource['data']['stroke_color'] - b * 65536) / 256);
          var r = parseInt(resource['data']['stroke_color'] - b * 65536 - g * 256);
          var color = tinycolor('rgb(' + r + ',' + g + ',' + b + ')');

          resource['data']['stroke_color'] = color.toHexString();

          var b = parseInt(resource['data']['color_code'] / 65536);
          var g = parseInt((resource['data']['color_code'] - b * 65536) / 256);
          var r = parseInt(resource['data']['color_code'] - b * 65536 - g * 256);
          var color = tinycolor('rgb(' + r + ',' + g + ',' + b + ')');

          resource['data']['color_code'] = color.toHexString();
        }
        if (resource['data']['source']) {
          var source = resource['data']['source'];

          resource['data']['tab'] = ImagesFactory.getVersionUrl(source, 'tab');
          resource['data']['web'] = ImagesFactory.getVersionUrl(source, 'web');
          resource['data']['thumb'] = ImagesFactory.getVersionUrl(source, 'thumb');
          resource['data']['mobile'] = ImagesFactory.getVersionUrl(source, 'mobile');
          resource['data']['largeweb'] = ImagesFactory.getVersionUrl(source, 'largeweb');
          resource['data']['original'] = source;
        }
      });
    } else {
      return resources;
    }
  }
});
